<div class="status-container">
  <!-- to show the report/status of after uploading CSV -->
  @if (data.category == 'csv-upload') {
    <div class="status-info text-center">
      <h4 class="text-center messageClass">{{ message }}</h4>
      @if (statusData && statusData.length > 0) {
        <div class="table-scroll table-hover mt-25">
          <table class="table">
            <thead>
              <tr>
                <th>{{ name }}</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              @for (error of statusData; track error) {
                <tr>
                  <td>{{ error.id }}</td>
                  <td>{{ error.message }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      <button class="create-action" type="button" class="btn-status mr-10" (click)="closeModal('close')">
        Okay
      </button>
      @if (statusData && statusData.length > 0) {
        <button type="button" class="btn-status"
          (click)="closeModal('download')">
          Download
        </button>
      }
    </div>
  }
</div>